import React from 'react'
import { FormattedDate } from 'react-intl'
import { useParams } from 'react-router-dom'
import { MetaData } from 'components/MetaData'
import { EmptyContainer, FadeIn, Spinner } from 'lib/ui/components'
import { NoMatch } from 'lib/shared/scenes/NoMatch'
import { useBlogPost } from 'hooks/blog'
import { PostTile } from '../../components/PostTile'
import { Breadcrumbs } from 'components/Breadcrumbs'
import { SocialShare } from './components/SocialShare'
import { Container } from './components/Styled'
import { SidebarBlocks } from '../../components/SidebarBlocks'

export const Post = () => {
  const params: any = useParams()
  const slug: string = params.slug
  const {
    title,
    content,
    author,
    publishDate,
    relatedPosts,
    isFirstLoad,
    isFailure,
    metaTitle,
    metaDescription,
    tags
  } = useBlogPost(slug)

  const tag = tags?.[0]?.tag_url_key
  if (isFailure) {
    return (
      <NoMatch />
    )
  }

  return (
    <>
      {isFirstLoad ? (
        <EmptyContainer>
          <Spinner />
        </EmptyContainer>
      ) : (
        <Container>
          {(metaTitle ?? title) && (
            <MetaData
              title={metaTitle ?? title}
              description={metaDescription}
            />
          )}

          <FadeIn
            key={slug}
          >
            <Breadcrumbs
              title={title}
            />
            <div className='post-intro'>
              <h1>
                {title}
              </h1>
            </div>

            <div className='post-content'>
              <SidebarBlocks slug={tag} />
              <div
                dangerouslySetInnerHTML={{
                  __html: content ?? ''
                }}
              />
            </div>

            <div className='post-extra'>
              {author && (
                <div className='author'>
                  {author}
                </div>
              )}
              <div>
                <SocialShare
                  title={title}
                />
              </div>
              <div className='date'>
                <FormattedDate
                  value={publishDate}
                  year='numeric'
                  month='long'
                  day='2-digit'
                />
              </div>
            </div>
            <h2 className='related-title'>You may be Interested in these articles too.</h2>
            <div className='post-related'>
              {relatedPosts?.map((post: any) => {
                const { post_image: image, title, url_key: slug } = post ?? {}
                return (
                  <PostTile
                    key={slug}
                    image={image}
                    title={title}
                    link={`/blog/post/${slug}`}
                  />
                )
              })}
            </div>
          </FadeIn>
        </Container>
      )}
    </>
  )
}
